import { render } from "./InputPracticeType.vue?vue&type=template&id=ca100a96&ts=true"
import script from "./InputPracticeType.vue?vue&type=script&lang=ts"
export * from "./InputPracticeType.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__